import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ButtonMediumNunito, AccentButtonMediumNunito } from '../../../../../styledComponents/styles/Buttons.styled';
import GenericStyledModal from './GenericStyledModal.modal';
import { Paragraph } from '../../../../../styledComponents/styles/Paragraph.styled';
import styled from 'styled-components';
import { InfoIcon } from '../../../../../styledComponents/styles/IconCustom.styled';
import { sendRecommendationEmail } from '../../../../../actions/formsActions';

const ButtonContainer = styled.div`
  background: #ebebeb;
  display: flex;
  height: 111px;
  justify-content: flex-end;
  left: 0;
  top: 273px;
  width: 100%;
  margin-bottom: -20px;
`;

const ButtonDiv = styled.div`
  margin-top: 30px;
  margin-right: 20px;
`;

const FlexContainer = styled.div`
  display: grid;
  grid-template-areas: 'image main';
  grid-template-columns: 1fr;
  transition: all 0.25s ease-in-out;
  padding: 30px 0;

  @media (max-width: 550px) {
    grid-template-areas:
      'image'
      'main';
  }
`;

const ImageContainer = styled.div`
  grid-area: image;
  margin-right: 30px;
  padding-left: 40px;
`;

const Main = styled.main`
  grid-area: main;
  margin-right: 37px;
  @media (max-width: 480px) {
    padding:20px;
  }
`;

export default function RecommendationRequestModal(props) {
  const dispatch = useDispatch();

  const submitEmail = () => {
    dispatch(sendRecommendationEmail(props.question.question_id, props.formId, props.requestedRecommender));
    props.setShowRecommendationRequest(!props.showing);
  };
  return (
    <GenericStyledModal
      header={'Recommendation Request'}
      showing={props.showing}
      maxWidth={'520px'}
      onClose={() => {
        props.setShowRecommendationRequest(!props.showing);
      }}
    >
      <FlexContainer>
        <Main>
          <Paragraph>You are about to send a recommendation request to:</Paragraph>
          <Paragraph>{props.requestedRecommender}</Paragraph>
          <Paragraph>
            They will receive an email with instructions and a link to a form where a Recommendation/Approval can be submitted.
          </Paragraph>
        </Main>
        <ImageContainer>
          <InfoIcon size={'125px'} />
        </ImageContainer>
      </FlexContainer>

      <ButtonContainer>
        <ButtonDiv>
          <ButtonMediumNunito
            onClick={() => {
              props.setShowRecommendationRequest(!props.showing);
            }}
          >
            Cancel
          </ButtonMediumNunito>
        </ButtonDiv>
        <ButtonDiv>
          <AccentButtonMediumNunito
            onClick={() => {
              submitEmail();
            }}
          >
            Send Request
          </AccentButtonMediumNunito>
        </ButtonDiv>
      </ButtonContainer>
    </GenericStyledModal>
  );
}
